const validate = (values, props) => {
    const errors = {};
    const cmeUno = props.cmeUno;
    if (!values.userName  || values.userName === ""){
        errors.userName = cmeUno.validationData.requiredUserName;
    }
    if ((!values.captchaResponse || values.captchaResponse === "") && !window.grecaptcha){
        errors.captchaResponse = cmeUno.validationData.captchaResponse.messages.required;
    }
    return errors;
};

export default validate;